import React from 'react';
import { Button, IconButton } from '@mui/material';
import { ITableCellAction } from './interfaces';

export const TableCellAction: React.FC<ITableCellAction> = ({
  label,
  icon: Icon,
  onClick,
  color = 'default',
  disabled,
  ...props
}): JSX.Element => {
  const handleClick: React.MouseEventHandler<HTMLLabelElement> = (event) => {
    event.stopPropagation();

    if (onClick) {
      onClick();
    }
  };

  if (label) {
    return (
      <Button
        size="small"
        component="label"
        variant="outlined"
        tabIndex={-1}
        startIcon={<Icon />}
        color={color}
        disabled={disabled}
        onClick={handleClick}
        sx={{
          whiteSpace: 'nowrap',
          flexShrink: 0,
          maxWidth: 'none',
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <IconButton
      {...props}
      color={color}
      disabled={disabled}
      onClick={handleClick}
    >
      <Icon
        sx={{
          width: '18px',
          height: '18px',
        }}
      />
    </IconButton>
  );
};
